import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigStructure } from 'src/app/config/config-structure.model';
import { DescriptorEnum } from 'src/app/config/descriptors/descriptor.enum';
import { Property } from '../property/property.model';
import { TranslatorService } from '../translator.service';

@Component({
  selector: 'app-personal-descriptor-metadata',
  templateUrl: './personal-descriptor-metadata.component.html',
  styleUrls: ['./personal-descriptor-metadata.component.scss']
})
export class PersonalDescriptorMetadataComponent implements OnInit {
  static MOBILE_DETAILS_LIMIT = 2;

  @Input() descType: DescriptorEnum;

  @Input() onlyOneColumn: boolean = false;

  @Input() disableShowMore: false;

  @Input() statsLibTxt;

  @Input() hideSearchListElements = true;

  @Input() wikiData;

  @Input() wikiDataId;

  @Input() strippedVersion: boolean;

  @Input() objectVersion: boolean;

  @Input() showMulti: boolean;


  @Input() set properties(value: Property[]) {
    if (value) {
      this._properties = this.convertProperty(value);
      this.propertiesReady = true;
    }
  }

  @Input() set config(value: ConfigStructure[]) {
    if (value) {
      this._config = value;
      this.configReady = true;
    }
  }

  @Input() set viafId(value: string) {
    if (value) {
      this.viafCompleteUrl = value;
    }
  }

  propertyOrder = [
    "alternateNames",
    "nlpId",
    "controlNumber",
    "mmsId"
  ]

  maxAlternateNames = 3;

  geographicalDesc = false;

  characterLimit: number = 20;

  private propertiesReady = false;

  private configReady = false;

  viafCompleteUrl = "";

  _properties: Property[] = [];

  private _config: ConfigStructure[] = [];




  propertiesRawObjectReady: boolean = false;

  constructor(private translator: TranslatorService, protected modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.propertiesReady && this.configReady) {
     // this.updateElements();
    }
  }

  showHideAlternateNames(propertyLength: number) {
    this.maxAlternateNames = this.maxAlternateNames === 3 ? propertyLength : 3;
  }



  convertProperty(properties : any) {
    properties = properties.filter(property =>  (this.propertyOrder).indexOf(property.name) > -1);
    properties.sort((a,b) => this.propertyOrder.indexOf(a.name) - this.propertyOrder.indexOf(b.name));
    return properties;
  }

  getValue(value : string) {

    let property = this._properties.find((property)=>{
      return property.value === value;
    });
    return property || false;
  }

  ngOnInit() {
    this.geographicalDesc = (DescriptorEnum.GEOGRAPHICAL === this.descType);
  }

  get properties(): Property[] {
    return this._properties;
  }


}

